import React from 'react';
import { connectToJSContext } from '../utils.jsx';

class ReviewTracker extends React.Component {
    componentDidMount() {
        const body = document.body || document.getElementsByTagName('body')[0];
        const reviewTrackerScript = document.createElement('script');
        reviewTrackerScript.type = 'text/javascript';
        reviewTrackerScript.src = 'https://amplify.review-alerts.com/widget-init.js';
        body.appendChild(reviewTrackerScript);
    }
    render() {
        const {
            reviewTrackerToken,
            reviewTrackerExternalId,
            reviewTrackerWidgetId,
            reviewTrackerQuote,
            reviewTrackerQuotationMarkSrc
        } = this.props;
        return (
            <div className="c-review-tracker">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div
                                className="amplify-widget"
                                data-token={reviewTrackerToken}
                                data-external-id={reviewTrackerExternalId}
                                data-widget-id={reviewTrackerWidgetId}
                                data-widget-type="star_snapshot"
                            />
                        </div>
                        <div className="col-xs-12 col-md-6 c-review-tracker__quote-wrapper">
                            <img className="c-review-tracker__quotation_mark"
                                alt=""
                                src={reviewTrackerQuotationMarkSrc}
                            />
                            <span className="c-review-tracker__quote">{reviewTrackerQuote}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    profile: {
        review_tracker_token: reviewTrackerToken,
        review_tracker_external_id: reviewTrackerExternalId,
        review_tracker_widget_id: reviewTrackerWidgetId,
        review_tracker_quote: reviewTrackerQuote,
        review_tracker_quotation_mark_src: reviewTrackerQuotationMarkSrc
    }
}) => ({
    reviewTrackerToken,
    reviewTrackerExternalId,
    reviewTrackerWidgetId,
    reviewTrackerQuote,
    reviewTrackerQuotationMarkSrc
});

export default connectToJSContext(mapStateToProps)(ReviewTracker);



// WEBPACK FOOTER //
// ./components/review_tracker/index.jsx